import {useTranslation} from 'react-i18next'
import {CableIcon} from '../../../icons/CableIcon'
import {useAppNavigation} from '../../../hooks/useAppNavigation'

export const stepName = 'connectPayoutAccount'

// A support request awaiting review (pending), or already approved but not yet
// finished setting up, keeps the step in the read-only "reviewing" state.
const REVIEWING_STATUSES = ['pending', 'approved']

const calculateStatus = ({
  payoutAccountConnected,
  payoutAccountSupportRequestStatus,
}) => {
  if (payoutAccountConnected) {
    return 'completed'
  }

  if (REVIEWING_STATUSES.includes(payoutAccountSupportRequestStatus)) {
    return 'reviewing'
  }

  return 'incomplete'
}

export default (stepperData) => {
  const navigate = useAppNavigation()
  const {t} = useTranslation('connectPayoutAccount')

  const handleOnClick = () => {
    navigate('/connect_payout_account')
  }

  const status = calculateStatus(stepperData)
  const prerequisiteStepsCompleted =
    stepperData.verificationStatus === 'verified' &&
    stepperData.supplierAgreementAccepted
  // A denied request blocks the supplier from nominating again.
  const isDenied = stepperData.payoutAccountSupportRequestStatus === 'denied'

  return {
    name: stepName,
    visible: stepperData.showingBankConnectionStep,
    status,
    active: status === 'incomplete' && prerequisiteStepsCompleted && !isDenied,
    icon: <CableIcon />,
    title: t('stepper.title'),
    subtitle: {default: t('stepper.tooltip')},
    action: {
      label: t('stepper.button'),
      onClick: handleOnClick,
    },
  }
}
